import ModelEntity from "../../../model-entity";
import {EntityType} from "../../../../gd/const/item";
import {AIChatContextType} from "../../@const";
import Task from "../../../task/task";


export default class AIChatContext extends ModelEntity {

    public type             : AIChatContextType
    public taskId?          : ID | null
    public projectId?       : ID | null
    public selectedText?    : string | null
    public currentUserInfo  : any


    public task             : Task // not stored in bd - backend returns in when init chat

    constructor(data: any) {
        super("", EntityType.DYNAMIC_MODEL);

        this.type               = data.type;
        this.taskId             = data.taskId;
        this.projectId          = data.projectId;
        this.selectedText       = data.selectedText;
        this.currentUserInfo    = data.currentUserInfo;

        this.task               = data.task;

        if (!this.currentUserInfo){
            this.currentUserInfo = {
                id      : gd.user.id,
                name    : gd.user.name
            };
        }
    }

    get contextItem(){
        switch(this.type){
            case AIChatContextType.ALL_SPACES:
                return "All Spaces";
            case AIChatContextType.TASK:
                return "Task";
            case AIChatContextType.PROJECT:
                return "Project";
        }

    }

    toJSON() {

        const result: any = {
            type            : this.type,
            currentUserInfo : this.currentUserInfo,

        }

        if (this.type === AIChatContextType.TASK) {
            result['taskId'] = this.taskId
        }

        if (this.type === AIChatContextType.PROJECT) {
            result['projectId'] = this.projectId
        }
        if (this.selectedText) {
            result['selectedText'] = this.selectedText
        }

        return result
    }
}
